import { BadgeCheck, TriangleAlert, X } from "lucide-react";
import { useHome } from "../state";

/**
 * Global bottom toast (spec §2.7). Error takes priority over success;
 * auto-dismissal (5s) is handled by the state provider.
 */
export function Toasts() {
  const { error, success, dismissError, dismissSuccess } = useHome();
  const isError = Boolean(error);
  const message = error || success;
  if (!message) return null;

  return (
    <div className="toast" role="status">
      {isError ? (
        <TriangleAlert size={20} strokeWidth={2.4} style={{ color: "var(--warm)" }} />
      ) : (
        <BadgeCheck size={20} strokeWidth={2.4} style={{ color: "var(--cool)" }} />
      )}
      <p className="toast-message">{message}</p>
      <button
        type="button"
        className="toast-dismiss"
        aria-label="Dismiss"
        onClick={isError ? dismissError : dismissSuccess}
      >
        <X size={12} strokeWidth={3.2} />
      </button>
    </div>
  );
}
